import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import TaskCard from "@/components/management/reportManage/taskCard";
import AddOrEdit from "@/components/management/reportManage/addOrEdit";
import ChargePerson from "@/components/management/reportManage/chargePerson";
import DepTree from "@/components/management/user/DepTree";
import { tHallBatchReportList, tHallBatchReportListUsers, tHallBatchReportStatus, tHallBatchReportSaveUsers, tHallBatchReportDeleteUsers, deleteReportId } from "@/api/management/report";
import { bpmnNoticeVisitUrl } from "@/api/bpmnApi/bpmn";
import { mapGetters } from "vuex";
import * as orignAxios from "axios";
export default {
  name: "reportManage",
  components: {
    TaskCard: TaskCard,
    Sift: Sift,
    AddOrEdit: AddOrEdit,
    DepTree: DepTree,
    ChargePerson: ChargePerson
  },
  props: [],
  data: function data() {
    return {
      reportList: [],
      userList: [],
      loading1: false,
      loading2: false,
      reportListPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      userListPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      multipleSelection: [],
      siftData: [{
        type: "select",
        key: "reportStatus",
        label: "上报进度",
        placeholder: "",
        default: "",
        data: [{
          label: "未上报",
          value: "0"
        }, {
          label: "已上报",
          value: "1"
        } // {label: '已上报', value: '2'},
        ],
        col: 6
      }, {
        type: "bedate",
        key: "start,end",
        label: "上报时间",
        placeholder: "",
        defaultValue: "",
        pickerType: "date",
        // 传给时间组件的type = week、month、year、date
        sysDatasourceQuery: true,
        //传给时间组件是否需要自选格式
        optionalType: "yyyy-MM-dd",
        // 需要的时间格式
        default: "",
        col: 6
      }, {
        type: "text",
        key: "keywords",
        label: "关键字",
        placeholder: "",
        default: "",
        col: 6
      }],
      propData: [],
      dep: {
        id: "",
        name: "",
        parentId: ""
      },
      activeReport: {},
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: null
      },
      keywords: "",
      dialogVisible: false,
      names: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["chooseDept"])),
  created: function created() {
    this.getReportList();
    this.getUserTree();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    subClick: function subClick() {
      if (this.names) {
        var params = {
          downloadName: this.names,
          insetIds: this.multipleSelection.map(function (item) {
            return item.processInstId;
          }).join(",")
        };
        var url = "gxdl/bpmn/batchDownloadAttach";
        this.downloadFn(url, params);
      } else {
        this.$message.error("请输入下载题目");
      }
    },
    expotCli: function expotCli() {
      if (this.multipleSelection.filter(function (item) {
        return item.processInstId;
      }).length > 0) {
        this.names = "";
        this.dialogVisible = true;
      } else {
        this.$message.error("您选择的选项都未上报，请选上报");
      }
    },
    downloadFn: function downloadFn(url, params) {
      var _this = this;

      this.$DownLoadL(url, params, function (res) {
        if (res.status == 200) {
          _this.dialogVisible = false;
        } else {
          _this.$alert(res.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.userListPagination.pageNum = 1;
      this.getReportUsers();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.userListPagination.pageSize = value;
      this.initPage();
    },
    // 上下页
    changePage: function changePage(value) {
      this.userListPagination.pageNum = value;
      this.getReportUsers();
    },
    // 显示部门弹框
    showDeptDialog: function showDeptDialog() {
      this.$refs.DetTree.dialogShow();
    },
    // 部门树
    getUserTree: function getUserTree() {
      this.propData = this.chooseDept;
    },
    // 设置选中的部门数据
    setDepData: function setDepData(data) {
      this.dep.id = data ? data.id : "";
      this.dep.name = data ? data.name : "";
      this.initPage();
    },
    pause: function pause() {
      var _this2 = this;

      if (this.activeReport.status == "2") {
        this.$confirm("是否取消暂停该任务", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          tHallBatchReportStatus({
            id: _this2.activeReport.id,
            status: "1"
          }).then(function (_ref) {
            var data = _ref.data;

            if (data.code == 0) {
              _this2.$message.success("取消暂停成功");

              _this2.getReportList();
            } else {
              _this2.$message.error(data.msg);
            }
          }).catch(function () {
            _this2.$message.error("取消暂停失败");
          });
        });
      } else if (this.activeReport.status == "1") {
        this.$confirm("是否暂停该任务,暂停后用户将无法进行上报", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          tHallBatchReportStatus({
            id: _this2.activeReport.id,
            status: "2" // 暂停

          }).then(function (_ref2) {
            var data = _ref2.data;

            if (data.code == 0) {
              _this2.$message.success("暂停任务成功");

              _this2.getReportList();
            } else {
              _this2.$message.error(data.msg);
            }
          }).catch(function () {
            _this2.$message.error("暂停任务失败");
          });
        });
      } else {
        this.$message.warning("该任务不在进行中,无法暂停");
      }
    },
    editTask: function editTask() {
      this.$refs.addOrEdit.dialogShow("edit", this.activeReport);
    },
    addUser: function addUser() {
      this.personData.state = true;
    },
    batchDelete: function batchDelete() {
      var _this3 = this;

      if (this.multipleSelection.length > 0) {
        this.$confirm("确认要删除选中的人员吗?", "系统消息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var ids = "";

          _this3.multipleSelection.forEach(function (item, index) {
            if (index != _this3.multipleSelection.length - 1) {
              ids += item.id + ",";
            } else {
              ids += item.id;
            }
          });

          tHallBatchReportDeleteUsers({
            reportId: _this3.activeReport.id,
            ids: ids
          }).then(function (res) {
            if (res.data.code == 0) {
              _this3.$message.success("删除成功");

              _this3.initPage();
            } else {
              _this3.$notify({
                title: "提示",
                type: "warning",
                message: "".concat(res.data.msg)
              });
            }
          }).catch(function (err) {});
        });
      } else {
        this.$message.closeAll();
        this.$message.warning("请选择目标项");
      }
    },
    hastenWork: function hastenWork() {},
    reset: function reset() {},
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getReportUsers: function getReportUsers() {
      var _this4 = this;

      this.loading2 = true;
      console.log(this.$refs.needSift.getValue());
      var searchData = this.$refs.needSift.getValue();
      var data = {
        beginDate: searchData.start || "",
        endDate: searchData.end || "",
        keywords: searchData.keywords,
        reportStatus: searchData.reportStatus,
        current: this.userListPagination.pageNum,
        size: this.userListPagination.pageSize,
        reportId: this.activeReport.id,
        deptId: this.dep.id
      }; // Object.assign(data, searchData)

      tHallBatchReportListUsers(data).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.userList = data.data.records;
          _this4.userListPagination.total = data.data.total;
        } else {
          _this4.$message.error(data.msg);
        }
      }).finally(function () {
        _this4.loading2 = false;
      });
    },
    taskPageChange: function taskPageChange(val) {
      this.reportListPagination.pageNum = val;
      this.getReportList();
    },
    initReportList: function initReportList() {
      this.reportListPagination.pageNum = 1;
      this.getReportList();
    },
    getReportList: function getReportList() {
      var _this5 = this;

      this.loading1 = true;
      var params = {
        keywords: this.keywords,
        size: this.reportListPagination.pageSize,
        current: this.reportListPagination.pageNum
      };
      tHallBatchReportList(params).then(function (_ref4) {
        var data = _ref4.data;
        _this5.reportList = data.data.records || [];
        _this5.activeReport = data.data.records[0] || {};
        _this5.reportListPagination.total = data.data.total;
        _this5.loading1 = false;
      }).catch(function () {
        _this5.loading1 = false;
      });
    },
    cardClick: function cardClick(item) {
      this.activeReport = item;
    },
    handleAdd: function handleAdd() {
      this.$refs.addOrEdit.dialogShow("add");
    },
    onTaskSubmit: function onTaskSubmit() {
      this.getReportList();
    },
    closePerson: function closePerson(obj) {
      var _this6 = this;

      if (!obj.mans) {
        this.personData.state = false;
        return;
      }

      for (var i = 0; i < obj.data.length; i++) {
        if (isNaN(obj.data[i])) {
          obj.data.splice(i, 1);
        }
      } // if (obj.data.length > 0) {
      //   this.formValidate.userIds = obj.data;
      // }


      this.personData.userData = obj.data;
      this.personData.state = false; // this.planpermissionUserSubmit();

      if (obj.data.length == 0) {
        this.$message.warning("请选择追加人员");
        return;
      }

      var params = {
        reportId: this.activeReport.id,
        userId: obj.data
      };
      tHallBatchReportSaveUsers(params).then(function (_ref5) {
        var data = _ref5.data;

        if (data.code == 0) {
          _this6.getReportList();

          _this6.$message.success("操作成功");
        } else {
          _this6.$message.error(data.msg);
        }
      });
    },
    getBpmnNoticeVisitUrl: function getBpmnNoticeVisitUrl(row) {
      var _this7 = this;

      var params = {
        taskId: row.taskInstId,
        instId: row.processInstId
      };
      bpmnNoticeVisitUrl(params).then(function (_ref6) {
        var data = _ref6.data;

        if (data.code == 0) {
          window.open(data.data);
        } else {
          _this7.$message.error(data.msg || "请求失败");
        }
      }).catch(function (err) {});
    },
    addOk: function addOk() {
      var _this8 = this;

      this.$confirm("确认要催办吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: function callback(action) {
          if (action === "cancel") {
            return;
          }

          _this8.$message.success("催办成功");
        }
      });
    },
    delTask: function delTask() {
      var _this9 = this;

      this.$confirm("\u786E\u8BA4\u8981\u5220\u9664".concat(this.activeReport.reportName, "\u586B\u62A5\u4EFB\u52A1\u5417?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        deleteReportId({
          ids: _this9.activeReport.id
        }).then(function (res) {
          if (res.data.code == 0) {
            _this9.$message.success("删除成功");

            _this9.getReportList();
          } else {
            _this9.$notify({
              title: "提示",
              type: "warning",
              message: "".concat(res.data.msg)
            });
          }
        }).catch(function (err) {});
      });
    },
    deleteOne: function deleteOne(row) {
      var _this10 = this;

      this.$confirm("\u786E\u8BA4\u8981\u5220\u9664".concat(row.userName, "\u5417?"), "系统消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        tHallBatchReportDeleteUsers({
          reportId: _this10.activeReport.id,
          ids: row.id
        }).then(function (res) {
          if (res.data.code == 0) {
            _this10.$message.success("删除成功");

            _this10.initPage();
          } else {
            _this10.$notify({
              title: "提示",
              type: "warning",
              message: "".concat(res.data.msg)
            });
          }
        }).catch(function (err) {});
      });
    }
  },
  watch: {
    activeReport: function activeReport(val) {
      var _this11 = this;

      if (val.id) {
        this.$nextTick(function () {
          _this11.initPage();
        });
      }
    }
  },
  filters: {}
};